const teantPermissionGroups = {
    'API Setting Management': ['create-api-setting', 'read-api-setting', 'update-api-setting', 'destroy-api-setting'],
    // 'Alitiq Setting Management': ['create-alitiq', 'read-alitiq', 'update-alitiq', 'destroy-alitiq'],
    'Dashboard/Profile Management': ['read-dashboard', 'read-profile', 'update-profile'],
    'Fleet Management': ['create-fleet', 'read-fleet', 'update-fleet', 'destroy-fleet'],
    'Forecast Management': ['create-forecast', 'read-forecast', 'update-forecast', 'destroy-forecast'],
    'Report Management': ['read-report'],
    // 'Role Management': ['create-role', 'read-role', 'update-role', 'destroy-role'],
    'System Management': ['create-system', 'read-system', 'update-system', 'destroy-system'],
    'Site Management': ['create-site', 'read-site', 'update-site', 'destroy-site'],
    'Building Management': ['create-building', 'read-building', 'update-building', 'destroy-building'],
    'Space Management': ['create-space', 'read-space', 'update-space', 'destroy-space'],
    'Storey Management': ['create-storey', 'read-storey', 'update-storey', 'destroy-storey'],
    'Device Management': ['create-device', 'read-device', 'update-device', 'destroy-device'],
    'Sub-Tenant Management': ['create-sub-tenant', 'read-sub-tenant', 'update-sub-tenant', 'destroy-sub-tenant'],
    // 'User Management': ['create-user', 'read-user', 'update-user', 'destroy-user'],
    // 'Notification Management': ['read-notification', 'update-notification'],
    'Market Management': ['read-market'],
    'Configuration Management': ['update-configuration'],
};

const superadminPermissionGroups = {
    'Dashboard/Profile Management': ['read-dashboard', 'read-profile', 'update-profile'],
    'Tenant Management': ['create-tenant', 'read-tenant', 'update-tenant', 'destroy-tenant'],
    'Company Management': ['create-company', 'read-company', 'update-company', 'destroy-company'],
    // 'Role Management': ['create-role', 'read-role', 'update-role', 'destroy-role'],
    'User Management': ['create-user', 'read-user', 'update-user', 'destroy-user'],
};

export const getPermissionGroups = (role: any) => {
    if (role === 'super-admin' || role === 'support-superadmin') {
        return superadminPermissionGroups;
    } else if (role === 'tenant' || role === 'sub-tenant' || role === 'support-tenant') {
        return teantPermissionGroups;
    }
    return {};
}